import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Chip,
  CircularProgress,
  Alert,
  Collapse,
  IconButton,
  Tooltip,
  Paper,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ArticleIcon from '@mui/icons-material/Article';
import FolderIcon from '@mui/icons-material/Folder';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import ReactMarkdown from 'react-markdown';

const ALL_DOCS: string[] = [
  'ALLOW_SKIP_DVLA_FIX.md',
  'ALL_CHECKS_OFFLINE_ANALYSIS.md',
  'ASSETS_MANAGEMENT_TOGGLE.md',
  'ASSET_LOCATIONS_UPDATE_FIX.md',
  'ASSET_MANAGEMENT_MOBILE.md',
  'ASSET_SEARCH_FILTER_FEATURE.md',
  'ASSET_SEARCH_FILTER_SUMMARY.md',
  'ASSET_TYPE_TRANSFER_IMPLEMENTATION.md',
  'ASSET_TYPE_TRANSFER_SUMMARY.md',
  'BACKEND_OFFLINE_LOAN_ID_TEST.md',
  'BUSINESS_TYPE_ANALYSIS.md',
  'CAMERA_QR_SCANNER_READY.md',
  'COMMUNICATIONS_MODULE_GUIDE.md',
  'COMPLETE_OFFLINE_MODE_VERIFICATION.md',
  'CONDITIONAL_LOGIC_ALL_QUESTION_TYPES.md',
  'CONDITIONAL_LOGIC_BEFORE_AFTER.md',
  'CONDITIONAL_LOGIC_ENHANCEMENT_SUMMARY.md',
  'CONDITIONAL_LOGIC_IMPLEMENTATION_COMPLETE.md',
  'CONDITIONAL_LOGIC_MULTI_SELECT_FIX.md',
  'CONDITIONAL_LOGIC_QUICKSTART.md',
  'CONDITIONAL_LOGIC_QUICK_REFERENCE.md',
  'CONDITIONAL_LOGIC_TESTING_GUIDE.md',
  'CONDITION_IMAGES_IMPLEMENTATION.md',
  'CONDITION_IMAGE_SYNC_FIX.md',
  'CUSTOM_FIELDS_IMPLEMENTATION.md',
  'CUSTOM_FIELDS_MOBILE_IMPLEMENTATION.md',
  'DASHBOARD_NAVIGATION_SUMMARY.md',
  'DASHBOARD_TO_ASSETS_NAVIGATION.md',
  'DEBUG_RESUMABLE.md',
  'DEEP_LINK_NAVIGATION_FIX.md',
  'DEEP_LINK_QR_FIX_SUMMARY.md',
  'DELIVERY_CHECKS_TOGGLE.md',
  'DELIVERY_CHECK_ARCHITECTURE_FIX.md',
  'DELIVERY_CHECK_EMAIL_FIX.md',
  'DELIVERY_CHECK_IMPLEMENTATION.md',
  'DELIVERY_CHECK_IMPLEMENTATION_COMPLETE.md',
  'DELIVERY_CHECK_STATUS.md',
  'DELIVERY_CONDITIONAL_LOGIC_FIX.md',
  'DELIVERY_OFFLINE_ANALYSIS.md',
  'DELIVERY_TEMPLATE_ASSET_TYPE_FILTER_FIX.md',
  'DEPLOY_CONDITIONAL_LOGIC_ENHANCEMENT.md',
  'DUPLICATE_OPTIONS_FIX.md',
  'DVLA_CREDIT_USAGE_PAGE.md',
  'DVLA_CREDIT_USAGE_PAGE_FINAL.md',
  'DVLA_LICENSE_REQUEST_IMPLEMENTATION_SUMMARY.md',
  'DVLA_SCANNER_IMPROVEMENTS.md',
  'DVLA_SYSTEMS_ANALYSIS.md',
  'DVLA_WEB_ADMIN_INTEGRATION.md',
  'EMAIL_CHECK_FEATURE_IMPLEMENTATION.md',
  'EMAIL_CHECK_QUICK_START.md',
  'FLEXIBLE_LOGIC_BUG_FIXES.md',
  'FLEXIBLE_LOGIC_CAMERA_FIX.md',
  'FLEXIBLE_LOGIC_QUESTION_ID_MISMATCH_FIX.md',
  'FLEXIBLE_LOGIC_RETURN_CHECK_FIX.md',
  'FLEXIBLE_LOGIC_RETURN_CHECK_HIDING.md',
  'FLEXIBLE_LOGIC_ROOT_CAUSE_ANALYSIS.md',
  'FLEXIBLE_LOGIC_UI_INTEGRATION.md',
  'FLEXIBLE_QUESTION_LOGIC_IMPLEMENTATION_SUMMARY.md',
  'FORCE_CONDITION_IMAGES_FEATURE.md',
  'FORCE_CONDITION_IMAGES_USER_GUIDE.md',
  'FRONTEND_LOAN_CYCLES_STATUS.md',
  'HARDCODED_TERMS_REMOVAL_SUMMARY.md',
  'IBCOS_OFFLINE_MODE_VERIFICATION.md',
  'IBCOS_TERMSKEYWORDS_BUG_FIX.md',
  'IMAGE_REQUIRED_SWITCH_CLEANUP.md',
  'IMMEDIATE_FIX_STEPS.md',
  'INSTALLATIONS_FEATURE.md',
  'LOAN_CHECK_ERROR_FIX.md',
  'LOAN_CHECK_IMPLEMENTATION.md',
  'LOAN_CYCLES_COMPREHENSIVE_FIX.md',
  'LOAN_DVLA_CREDIT_INTEGRATION.md',
  'LOAN_RETURN_DUPLICATE_QUESTIONS_FIX.md',
  'LOAN_RETURN_OFFLINE_TAGS_FIX.md',
  'LOAN_RETURN_SCREEN1_FIX.md',
  'LOCATION_HISTORY_FEATURE.md',
  'LOGGING_GUIDE.md',
  'LOGGING_OPTIMIZATION_SUMMARY.md',
  'LOGGING_TESTING_GUIDE.md',
  'MAP_SEARCH_FEATURE.md',
  'MOBILE_DVLA_SETUP_GUIDE.md',
  'MOBILE_USER_AGREEMENTS_COMPLETE.md',
  'MOBILE_USER_AGREEMENTS_IMPLEMENTATION.md',
  'MODERN_TEMPLATE_BUILDER_GUIDE.md',
  'MODERN_TEMPLATE_BUILDER_MIGRATION.md',
  'MODERN_TEMPLATE_BUILDER_QUICKSTART.md',
  'MULTIPLE_CHOICE_ERROR_FIX.md',
  'MULTI_BUSINESS_MANAGER_FEATURE.md',
  'MULTI_BUSINESS_MANAGER_SYNC_FIX.md',
  'MULTI_BUSINESS_SETUP.md',
  'MULTI_BUSINESS_TEMPLATE_FIX.md',
  'MULTI_SELECT_COMPLETE_COVERAGE.md',
  'MULTI_SELECT_FIX_COMPLETE.md',
  'MULTI_SELECT_MOBILE_IMPLEMENTATION.md',
  'NATIVE_CAMERA_QR_DEEP_LINKING.md',
  'NATIVE_CAMERA_QR_FIX.md',
  'NATIVE_QR_QUICK_START.md',
  'NO_TEMPLATES_OFFLINE_FIX.md',
  'NULL_BUSINESS_ID_FIX_QUICKSTART.md',
  'OFFLINE_ASSETS_FIX.md',
  'OFFLINE_DELIVERY_TEMPLATE_SELECTION_FIX.md',
  'OFFLINE_EMAIL_IMPLEMENTATION.md',
  'OFFLINE_FUNCTIONALITY_ANALYSIS.md',
  'OFFLINE_LOAN_ID_IMPLEMENTATION.md',
  'OFFLINE_LOAN_RETURN_ORIGINAL_RESPONSES_FIX.md',
  'OFFLINE_MODE_VERIFICATION.md',
  'OFFLINE_TEMPLATE_FILTERING_FIX.md',
  'OFFLINE_TEMPLATE_SELECTION_FIX.md',
  'OFFLINE_USER_AGREEMENTS_FIX.md',
  'OFFLINE_USER_AGREEMENTS_VERIFICATION.md',
  'OUTGOING_DELIVERY_EMAIL_CHECK_FIX.md',
  'OUTGOING_DELIVERY_EMAIL_CHECK_TEST_GUIDE.md',
  'OUTGOING_DELIVERY_IMPLEMENTATION_COMPLETE.md',
  'OUT_OF_ACTION_AUDIT_DISPLAY_FEATURE.md',
  'OUT_OF_ACTION_MARK_BACK_IN_ACTION_FEATURE.md',
  'OUT_OF_ACTION_SYNC_FIX.md',
  'PDF_ATTACHMENT_FIX.md',
  'PDF_DISPLAY_FIX.md',
  'PERFORMANCE_OPTIMIZATION.md',
  'QR_FIX_SUMMARY.md',
  'RELOAD_MOBILE_APP.md',
  'RESUMABLE_CHECKS_IMPLEMENTATION.md',
  'RESUMABLE_DEBUG_TEST.md',
  'RESUMABLE_RESPONSES_FIX.md',
  'SCHEDULED_ALERTS_COMPLETE_FLOW.md',
  'SCHEDULED_ALERTS_OVERDUE_INTEGRATION.md',
  'SENDER_EMAIL_MAPPINGS_GUIDE.md',
  'SERIAL_NUMBER_SCANNER_FEATURE.md',
  'SESSION_FIXES_SUMMARY_FEB_15_2026.md',
  'SHOW_CONDITIONS_COPY_FIX.md',
  'SHOW_CONDITIONS_FIX.md',
  'SIGNATURE_AND_AGREEMENTS_FIX_SUMMARY.md',
  'SIGNATURE_FORMAT_FIX.md',
  'SIGNATURE_RENDERING_IMPLEMENTATION.md',
  'SYNC_ORDER_VERIFICATION.md',
  'TEMPLATE_BUILDER_FEATURE_SHOWCASE.md',
  'TEMPLATE_CHECK_TYPE_AND_DELIVERY_TOGGLE.md',
  'TEMPLATE_COPY_RESPONSES_FIX.md',
  'TEMPLATE_DOWNLOAD_DEBUG_GUIDE.md',
  'TEMPLATE_FILTERING_DEBUG.md',
  'TEMPLATE_LOADING_PERFORMANCE_OPTIMIZATION.md',
  'TEMPLATE_USER_AGREEMENTS_IMPLEMENTATION.md',
  'TERMS_CONDITIONS_FORMATTING.md',
  'TEST_QR_CODES.md',
  'TEXT_HEADER_FEATURE.md',
  'TEXT_HEADER_IMPLEMENTATION_SUMMARY.md',
  'THIRD_PARTY_QR_IMPLEMENTATION.md',
  'THIRD_PARTY_QR_USAGE_GUIDE.md',
  'USER_AGREEMENTS_COMPLETE_FIX.md',
  'USER_AGREEMENTS_COMPLETE_SUMMARY.md',
  'USER_AGREEMENTS_DEBUG_ENHANCEMENT.md',
  'USER_AGREEMENTS_FINAL_FIX_SUMMARY.md',
  'USER_AGREEMENTS_FINAL_SUMMARY.md',
  'USER_AGREEMENTS_OFFLINE_FIX.md',
  'USER_AGREEMENTS_OFFLINE_IBCOS_COMPLETE.md',
  'USER_AGREEMENTS_QUICK_START.md',
  'USER_AGREEMENTS_SQL_COMPLETE_FIX.md',
  'USER_AGREEMENTS_SUMMARY.md',
  'USER_AGREEMENTS_TABLE_NAME_FIX.md',
  'USER_AGREEMENT_ACCEPTANCE_COMPLETE_FIX.md',
  'WHOLE_GOOD_NUMBER_COLUMN_NAME_FIX.md',
  'WHOLE_GOOD_NUMBER_FIX_SUMMARY.md',
  'WHOLE_GOOD_NUMBER_IMPORT_GUIDE.md',
  'WHOLE_GOOD_NUMBER_NOT_SAVING_FIX.md',
];

const CATEGORY_CONFIG: { label: string; color: string; prefixes: string[] }[] = [
  { label: 'Communications', color: '#0ea5e9', prefixes: ['COMMUNICATIONS'] },
  { label: 'Assets', color: '#7c3aed', prefixes: ['ASSET', 'ASSETS'] },
  { label: 'Business', color: '#0891b2', prefixes: ['BUSINESS', 'MULTI_BUSINESS', 'NULL_BUSINESS'] },
  { label: 'Conditional Logic', color: '#d97706', prefixes: ['CONDITIONAL_LOGIC', 'FLEXIBLE_LOGIC', 'FLEXIBLE_QUESTION', 'SHOW_CONDITIONS'] },
  { label: 'Condition Images', color: '#059669', prefixes: ['CONDITION_IMAGE', 'FORCE_CONDITION'] },
  { label: 'Custom Fields', color: '#dc2626', prefixes: ['CUSTOM_FIELDS'] },
  { label: 'Dashboard', color: '#7c3aed', prefixes: ['DASHBOARD'] },
  { label: 'Debug', color: '#6b7280', prefixes: ['DEBUG'] },
  { label: 'Deep Links & QR', color: '#be185d', prefixes: ['DEEP_LINK', 'QR_', 'NATIVE_CAMERA_QR', 'NATIVE_QR', 'CAMERA_QR', 'THIRD_PARTY_QR', 'TEST_QR'] },
  { label: 'Delivery Checks', color: '#0369a1', prefixes: ['DELIVERY'] },
  { label: 'DVLA', color: '#1e40af', prefixes: ['DVLA', 'MOBILE_DVLA', 'ALLOW_SKIP_DVLA', 'LOAN_DVLA'] },
  { label: 'Email & Notifications', color: '#b45309', prefixes: ['EMAIL', 'OUTGOING_DELIVERY_EMAIL', 'SENDER_EMAIL', 'SCHEDULED_ALERTS'] },
  { label: 'IBCOS', color: '#4338ca', prefixes: ['IBCOS'] },
  { label: 'Installations', color: '#065f46', prefixes: ['INSTALLATIONS'] },
  { label: 'Loans', color: '#9d174d', prefixes: ['LOAN', 'FRONTEND_LOAN'] },
  { label: 'Locations', color: '#92400e', prefixes: ['LOCATION', 'MAP_SEARCH'] },
  { label: 'Logging', color: '#374151', prefixes: ['LOGGING'] },
  { label: 'Mobile', color: '#1d4ed8', prefixes: ['MOBILE_USER', 'RELOAD_MOBILE', 'SERIAL_NUMBER'] },
  { label: 'Multi Select', color: '#0f766e', prefixes: ['MULTI_SELECT'] },
  { label: 'Offline Mode', color: '#92400e', prefixes: ['OFFLINE', 'ALL_CHECKS_OFFLINE', 'COMPLETE_OFFLINE', 'BACKEND_OFFLINE', 'IBCOS_OFFLINE'] },
  { label: 'Out of Action', color: '#991b1b', prefixes: ['OUT_OF_ACTION'] },
  { label: 'PDF & Signatures', color: '#7e22ce', prefixes: ['PDF', 'SIGNATURE'] },
  { label: 'Performance', color: '#065f46', prefixes: ['PERFORMANCE', 'TEMPLATE_LOADING'] },
  { label: 'QR Codes', color: '#be185d', prefixes: [] },
  { label: 'Resumable Checks', color: '#0c4a6e', prefixes: ['RESUMABLE'] },
  { label: 'Session & Auth', color: '#44403c', prefixes: ['SESSION_FIXES'] },
  { label: 'Templates', color: '#1e3a5f', prefixes: ['TEMPLATE', 'MODERN_TEMPLATE', 'DEPLOY_CONDITIONAL', 'DUPLICATE_OPTIONS', 'HARDCODED_TERMS'] },
  { label: 'Terms & Agreements', color: '#78350f', prefixes: ['USER_AGREEMENT', 'TERMS_CONDITIONS', 'IBCOS_TERMSKEYWORDS', 'SIGNATURE_AND', 'MOBILE_USER_AGREEMENTS'] },
  { label: 'Wholegood Number', color: '#134e4a', prefixes: ['WHOLE_GOOD'] },
  { label: 'Misc', color: '#6b7280', prefixes: [] },
];

function getCategoryForDoc(filename: string): string {
  const name = filename.replace('.md', '');
  for (const cat of CATEGORY_CONFIG) {
    if (cat.prefixes.length === 0) continue;
    for (const prefix of cat.prefixes) {
      if (name.startsWith(prefix)) return cat.label;
    }
  }
  return 'Misc';
}

function formatDocTitle(filename: string): string {
  return filename
    .replace('.md', '')
    .split('_')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

interface GroupedDocs {
  [category: string]: string[];
}

const Documentation: React.FC = () => {
  const [search, setSearch] = useState('');
  const [selectedDoc, setSelectedDoc] = useState<string | null>(null);
  const [docContent, setDocContent] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());
  const [copied, setCopied] = useState(false);

  const filteredDocs = useMemo(() => {
    if (!search.trim()) return ALL_DOCS;
    const q = search.toLowerCase();
    return ALL_DOCS.filter(
      doc =>
        doc.toLowerCase().includes(q) ||
        formatDocTitle(doc).toLowerCase().includes(q)
    );
  }, [search]);

  const groupedDocs = useMemo(() => {
    const groups: GroupedDocs = {};
    for (const doc of filteredDocs) {
      const cat = getCategoryForDoc(doc);
      if (!groups[cat]) groups[cat] = [];
      groups[cat].push(doc);
    }
    return groups;
  }, [filteredDocs]);

  const categories = useMemo(() => {
    return CATEGORY_CONFIG.map(c => c.label).filter(label => groupedDocs[label]?.length > 0);
  }, [groupedDocs]);

  useEffect(() => {
    if (search.trim()) {
      setExpandedCategories(new Set(categories));
    }
  }, [search, categories]);

  const toggleCategory = (cat: string) => {
    setExpandedCategories(prev => {
      const next = new Set(prev);
      if (next.has(cat)) next.delete(cat);
      else next.add(cat);
      return next;
    });
  };

  const loadDoc = async (filename: string) => {
    setSelectedDoc(filename);
    setLoading(true);
    setError(null);
    setDocContent('');
    try {
      const res = await fetch(`${process.env.PUBLIC_URL}/documentation/${filename}`);
      if (!res.ok) throw new Error(`Failed to load: ${res.statusText}`);
      const text = await res.text();
      setDocContent(text);
    } catch (e: any) {
      setError(e.message || 'Failed to load document');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    if (!docContent) return;
    await navigator.clipboard.writeText(docContent);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const getCategoryColor = (label: string): string => {
    return CATEGORY_CONFIG.find(c => c.label === label)?.color ?? '#6b7280';
  };

  return (
    <Box sx={{ display: 'flex', height: 'calc(100vh - 64px)', overflow: 'hidden' }}>
      {/* Left panel – doc list */}
      <Box
        sx={{
          width: 320,
          flexShrink: 0,
          borderRight: 1,
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Typography variant="h6" fontWeight={700} gutterBottom>
            Documentation
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" mb={1.5}>
            {ALL_DOCS.length} files available
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="Search docs…"
            value={search}
            onChange={e => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: search ? (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearch('')}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
          />
          {search && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
              {filteredDocs.length} result{filteredDocs.length !== 1 ? 's' : ''}
            </Typography>
          )}
        </Box>

        {/* Categories + files */}
        <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
          {categories.length === 0 ? (
            <Box sx={{ p: 3, textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                No documents found
              </Typography>
            </Box>
          ) : (
            <List dense disablePadding>
              {categories.map(cat => (
                <React.Fragment key={cat}>
                  <ListItemButton
                    onClick={() => toggleCategory(cat)}
                    sx={{
                      py: 0.75,
                      px: 2,
                      bgcolor: 'grey.50',
                      '&:hover': { bgcolor: 'grey.100' },
                    }}
                  >
                    <FolderIcon
                      fontSize="small"
                      sx={{ mr: 1, color: getCategoryColor(cat) }}
                    />
                    <ListItemText
                      primary={cat}
                      primaryTypographyProps={{
                        fontWeight: 600,
                        fontSize: '0.8rem',
                        color: getCategoryColor(cat),
                      }}
                    />
                    <Chip
                      label={groupedDocs[cat].length}
                      size="small"
                      sx={{
                        height: 18,
                        fontSize: '0.65rem',
                        mr: 0.5,
                        bgcolor: getCategoryColor(cat),
                        color: '#fff',
                      }}
                    />
                    {expandedCategories.has(cat) ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </ListItemButton>
                  <Collapse in={expandedCategories.has(cat)} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {groupedDocs[cat].map(doc => (
                        <ListItemButton
                          key={doc}
                          selected={selectedDoc === doc}
                          onClick={() => loadDoc(doc)}
                          sx={{
                            pl: 3,
                            py: 0.5,
                            '&.Mui-selected': {
                              bgcolor: 'primary.light',
                              '&:hover': { bgcolor: 'primary.light' },
                            },
                          }}
                        >
                          <ArticleIcon
                            fontSize="small"
                            sx={{ mr: 1, fontSize: '0.9rem', color: 'text.secondary' }}
                          />
                          <ListItemText
                            primary={formatDocTitle(doc)}
                            primaryTypographyProps={{
                              fontSize: '0.78rem',
                              noWrap: true,
                            }}
                          />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                  <Divider />
                </React.Fragment>
              ))}
            </List>
          )}
        </Box>
      </Box>

      {/* Right panel – doc viewer */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          bgcolor: '#fafafa',
        }}
      >
        {!selectedDoc ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              gap: 2,
              color: 'text.secondary',
            }}
          >
            <ArticleIcon sx={{ fontSize: 64, opacity: 0.3 }} />
            <Typography variant="h6" color="text.secondary">
              Select a document to read
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {ALL_DOCS.length} documentation files available
            </Typography>
          </Box>
        ) : (
          <>
            {/* Doc toolbar */}
            <Box
              sx={{
                px: 3,
                py: 1.5,
                borderBottom: 1,
                borderColor: 'divider',
                bgcolor: 'background.paper',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexShrink: 0,
              }}
            >
              <Box>
                <Typography variant="subtitle1" fontWeight={700} noWrap>
                  {formatDocTitle(selectedDoc)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {selectedDoc}
                </Typography>
              </Box>
              <Tooltip title={copied ? 'Copied!' : 'Copy raw content'}>
                <IconButton size="small" onClick={handleCopy} disabled={!docContent}>
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Doc content */}
            <Box sx={{ overflowY: 'auto', flexGrow: 1, p: 3 }}>
              {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
                  <CircularProgress />
                </Box>
              )}
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
              {!loading && !error && docContent && (
                <Paper
                  elevation={0}
                  sx={{
                    maxWidth: 900,
                    mx: 'auto',
                    p: 4,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    border: 1,
                    borderColor: 'divider',
                    '& h1': { fontSize: '1.8rem', fontWeight: 700, mt: 0, mb: 2, borderBottom: '2px solid', borderColor: 'divider', pb: 1 },
                    '& h2': { fontSize: '1.4rem', fontWeight: 700, mt: 3, mb: 1.5, color: 'primary.main' },
                    '& h3': { fontSize: '1.15rem', fontWeight: 600, mt: 2.5, mb: 1 },
                    '& h4': { fontSize: '1rem', fontWeight: 600, mt: 2, mb: 0.75 },
                    '& p': { lineHeight: 1.7, mb: 1.5 },
                    '& ul, & ol': { pl: 3, mb: 1.5 },
                    '& li': { mb: 0.5, lineHeight: 1.6 },
                    '& code': {
                      bgcolor: 'grey.100',
                      px: 0.75,
                      py: 0.25,
                      borderRadius: 0.5,
                      fontFamily: 'monospace',
                      fontSize: '0.85em',
                      color: 'error.dark',
                    },
                    '& pre': {
                      bgcolor: '#1e1e1e',
                      color: '#d4d4d4',
                      p: 2,
                      borderRadius: 1,
                      overflowX: 'auto',
                      mb: 2,
                      '& code': {
                        bgcolor: 'transparent',
                        color: 'inherit',
                        px: 0,
                        py: 0,
                      },
                    },
                    '& blockquote': {
                      borderLeft: '4px solid',
                      borderColor: 'primary.main',
                      pl: 2,
                      ml: 0,
                      color: 'text.secondary',
                      fontStyle: 'italic',
                    },
                    '& table': {
                      borderCollapse: 'collapse',
                      width: '100%',
                      mb: 2,
                    },
                    '& th': {
                      bgcolor: 'grey.100',
                      p: 1,
                      textAlign: 'left',
                      fontWeight: 700,
                      border: '1px solid',
                      borderColor: 'divider',
                    },
                    '& td': {
                      p: 1,
                      border: '1px solid',
                      borderColor: 'divider',
                      verticalAlign: 'top',
                    },
                    '& hr': { my: 3, borderColor: 'divider' },
                    '& a': { color: 'primary.main' },
                    '& strong': { fontWeight: 700 },
                  }}
                >
                  <ReactMarkdown>{docContent}</ReactMarkdown>
                </Paper>
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Documentation;
